import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import SalesAndBudgetsTable from './table';
import ChartSection from './chartSection';

class SalesAndBudgets extends Component {
  renderTables() {
    const {showData, loading, salesVsBudgets} = this.props;
    if (!showData) {
      return null;
    }
    if (loading) {
      return (
        <Card raised fluid>
          <Table striped>
            <Table.Body>
              <Table.Row>
                <Table.Cell colSpan='100%'>
                  <Loader active inline='centered' />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Card>
      );
    }

    if (!salesVsBudgets.length) {
      return (
        <Card raised fluid>
          <h3 className='without-data'>No hay datos disponibles con los filtros seleccionados</h3>
        </Card>
      );
    }

    return salesVsBudgets.map((element, index) => {
      return (
        <div key={index}>
          <ChartSection data={element} />
          <SalesAndBudgetsTable data={element} />
        </div>
      );
    });
  }

  render() {
    return (
      <div>
        {this.renderTables()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.sales.loadingSalesVsBudgets,
    'salesVsBudgets': state.sales.salesVsBudgets,
  };
};

export default connect(mapStateToProps, {
})(SalesAndBudgets);
